module.exports = __webpack_public_path__ + "static/media/loader.70705360.svg";